// extracted by mini-css-extract-plugin
export var lg = "_36-4";
export var md = "_36-3";
export var sm = "_36-2";
export var xs = "_36-1";
export var xxs = "_36-0";